import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LoginView } from './auth/login';
import { HomeView } from './home';
import { getAppManager } from './appmanager'

const renderEntry = () => {
    let manager = getAppManager();
    if(manager.IsLoggedIn()){
        return (<HomeView/>)
    }else{
        return (<LoginView/>);
    }
}
export const ApppView = () => {
    return (<Router>
        {renderEntry()}
    </Router>)
}